import { useQuery } from '@tanstack/react-query';
import { newsEntriesGetCurrentNews } from '~/generated';
import { extractData } from '~/utils/query-utils';

type Attachment = {
  id: number;
  blobId: string;
  fileName: string;
  contentType: string;
};

type NewsEntry = {
  id: number;
  title: string;
  date: string;
  content: string;
  revision: number;
  isRead: 'Unread' | 'ReadButChanged' | 'Read';
  attachments: Attachment[];
};

export const useCurrentNews = () =>
  useQuery({
    queryFn: async () => {
      const result = await extractData(newsEntriesGetCurrentNews());
      return result as unknown as NewsEntry[];
    },
    queryKey: ['NewsEntries', 'current'],
  });
